var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_861)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_127_861)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.875 6.33333H7.125C6.91504 6.33333 6.71367 6.41674 6.56521 6.56521C6.41674 6.71367 6.33333 6.91504 6.33333 7.125V30.875C6.33333 31.085 6.41674 31.2863 6.56521 31.4348C6.71367 31.5833 6.91504 31.6667 7.125 31.6667H30.875C31.085 31.6667 31.2863 31.5833 31.4348 31.4348C31.5833 31.2863 31.6667 31.085 31.6667 30.875V7.125C31.6667 6.91504 31.5833 6.71367 31.4348 6.56521C31.2863 6.41674 31.085 6.33333 30.875 6.33333ZM7.125 4.75C6.49511 4.75 5.89102 5.00022 5.44562 5.44562C5.00022 5.89102 4.75 6.49511 4.75 7.125V30.875C4.75 31.5049 5.00022 32.109 5.44562 32.5544C5.89102 32.9998 6.49511 33.25 7.125 33.25H30.875C31.5049 33.25 32.109 32.9998 32.5544 32.5544C32.9998 32.109 33.25 31.5049 33.25 30.875V7.125C33.25 6.49511 32.9998 5.89102 32.5544 5.44562C32.109 5.00022 31.5049 4.75 30.875 4.75H7.125Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_127_861)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2203 12.928C14.9196 13.1528 13.972 14.2548 13.8168 15.5658L12.6665 25.3334H25.3332L24.1805 15.5523C24.0269 14.2477 23.088 13.148 21.7944 12.9216C19.8548 12.582 18.2383 12.5788 16.2203 12.928ZM17.2028 16.3464C17.2235 16.1407 17.163 15.9351 17.0342 15.7734C16.9054 15.6117 16.7184 15.5069 16.5133 15.4812C16.3082 15.4556 16.1012 15.5112 15.9365 15.6362C15.7718 15.7612 15.6626 15.9456 15.6321 16.15L14.9156 21.8801C14.9001 21.9845 14.9055 22.091 14.9317 22.1932C14.9579 22.2954 15.0042 22.3914 15.068 22.4755C15.1318 22.5596 15.2118 22.63 15.3032 22.6827C15.3947 22.7354 15.4957 22.7693 15.6004 22.7824C15.7052 22.7955 15.8115 22.7875 15.9131 22.759C16.0146 22.7304 16.1095 22.6818 16.192 22.616C16.2746 22.5502 16.3431 22.4686 16.3937 22.3759C16.4442 22.2833 16.4757 22.1815 16.4863 22.0765L21 20L17.2028 16.3464Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_127_861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2915 19C10.2915 19.2668 10.3034 19.5304 10.3271 19.7916H7.9165V18.2083H10.3271C10.3034 18.4695 10.2915 18.7332 10.2915 19ZM11.8843 13.9776C11.579 14.4096 11.3138 14.8686 11.0919 15.3488L9.00584 14.1439L9.7975 12.7727L11.8843 13.9776ZM15.3479 11.0912C14.8658 11.3153 14.4074 11.5813 13.9783 11.8845L12.7726 9.79763L14.1438 9.00596L15.3479 11.092V11.0912ZM18.9998 10.2916C18.733 10.2916 18.4694 10.3035 18.2082 10.3273V7.91663H19.7915V10.3273C19.5283 10.3036 19.2641 10.2917 18.9998 10.2916ZM24.0222 11.8845C23.5902 11.5792 23.1312 11.3139 22.651 11.092L23.8559 9.00596L25.2271 9.79763L24.0222 11.8845ZM26.9086 15.348C26.6864 14.8683 26.4209 14.4099 26.1153 13.9784L28.2022 12.7727L28.9938 14.1439L26.9078 15.348H26.9086ZM27.7082 19C27.7082 18.7332 27.6963 18.4695 27.6725 18.2083H30.0832V19.7916H27.6725C27.6963 19.5304 27.7082 19.2668 27.7082 19Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_127_861",
    x: 0.75,
    y: 2.75,
    width: 36.5,
    height: 36.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_127_861",
    x: 8.6665,
    y: 10.6665,
    width: 20.6665,
    height: 20.6669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_127_861",
    x: 3.9165,
    y: 5.91663,
    width: 30.1665,
    height: 19.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.f6d171ff93df1b30e0ae320a93054e7e.svg";
export { ForwardRef as ReactComponent };